import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Button,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import axiosApi from "./../servicios/axios.service";
const NumericKeypadModal = ({
  open,
  onClose,
  onAction,
  // ultimotipo,
  mensaje,
  setMensaje,
  nombre,
  sedes,
  id_empresaSede,
  usuario,
}) => {
  const [input, setInput] = useState("");
  const [ultimotipo, setUltimotipo] = useState("");
  const [ultimoFichajeHora, setUltimoFichajeHora] = useState("");
  const [loadingEstado, setLoadingEstado] = useState(false);
  const [selectedSede, setSelectedSede] = useState(id_empresaSede); // Estado para la sede seleccionada

  // Filtrar las sedes para eliminar la que tiene id: 0
  const filteredSedes = sedes.filter((sede) => sede.id !== 0);

  const handleButtonClick = (value) => {
    if (input.length < 4) {
      // Limita la entrada a 4 dígitos
      setInput((prev) => prev + value);
    }
  };

  const handleClear = () => {
    setInput("");
    setMensaje("");
  };
  const handleSedeChange = (event) => {
    setSelectedSede(event.target.value); // Actualizar la sede seleccionada
  };
  const estaTrabajando = async () => {
    setLoadingEstado(true);
    try {
      const response = await axiosApi.axiosApi.get(
        `https://api.fichajedigital.com/api/panel/empleadossede?id_sede=${selectedSede}`,
      );
      console.log(response, usuario);
      response.data.forEach((element) => {
        if (element.idUsuario === usuario.idUsuario) {
          setUltimotipo(element.tipo);
          setUltimoFichajeHora(element.ultimoFichajeHora);
          console.log(
            element.enpausa,
            element.ultimoFichajeHora,
            element.tipo,
            element.trabajando,
          );
        }
      });
    } catch (error) {
      console.error("Error al obtener el usuario:", error);
    } finally {
      setLoadingEstado(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    estaTrabajando();
    setInput("");
    setMensaje("");
    setSelectedSede(id_empresaSede); // Reiniciar la sede seleccionada al abrir el modal
  }, [open, id_empresaSede]);
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          display: loadingEstado ? "none" : "block",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 300,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        {!loadingEstado && (
          <>
            <Typography variant="body2" gutterBottom>
              Último Fichaje ha sido {ultimotipo} a las {ultimoFichajeHora}
            </Typography>
            <Typography variant="button" gutterBottom>
              {nombre}
            </Typography>

            {/* Desplegable de sedes */}
            <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
              <InputLabel id="sede-select-label">
                Selecciona una sede
              </InputLabel>
              <Select
                labelId="sede-select-label"
                value={selectedSede}
                onChange={handleSedeChange}
                label="Selecciona una sede"
              >
                {filteredSedes.map((sede) => (
                  <MenuItem key={sede.id} value={sede.id}>
                    {sede.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Typography variant="h6" gutterBottom>
              Introduce tu PIN (4 digitos)
            </Typography>
            <Typography variant="h4" component="div" gutterBottom>
              {"*".repeat(input.length)}{" "}
              {/* Muestra asteriscos según la longitud de la entrada */}
            </Typography>
            <Grid container spacing={2}>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((number) => (
                <Grid item xs={4} key={number}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => handleButtonClick(number.toString())}
                  >
                    {number}
                  </Button>
                </Grid>
              ))}
            </Grid>
            <Button
              variant="outlined"
              fullWidth
              sx={{ mt: 2 }}
              onClick={handleClear}
            >
              Limpiar
            </Button>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={() => onAction("Entrada", input, selectedSede)}
                disabled={ultimotipo === "Entrada"} // Deshabilitar si ultimotipo es 'entrada'
              >
                Entrada
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => onAction("Salida", input, selectedSede)}
                disabled={ultimotipo === "Salida"} // Deshabilitar si ultimotipo es 'salida'
              >
                Salida
              </Button>
            </Box>

            {/* Botones de Pausa */}
            {/* 
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button
            variant="contained"
            color="success"
            disabled={usuario.enpausa}
            onClick={() => onAction('InicioPausa', input, selectedSede)}
          // disabled={ultimotipo === 'Entrada'}  // Deshabilitar si ultimotipo es 'entrada'
          >
            Inicio Pausa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => onAction('FinPausa', input, selectedSede)}
            disabled={!usuario.enpausa}
          >
            Fin Pausa
          </Button>
        </Box> */}

            {/* Fin Botones Pausa */}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              {mensaje}
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default NumericKeypadModal;
